import { FileText } from "lucide-react";
import { Input } from "@/components/ui/input";

// Company logo URL
const COMPANY_LOGO = "https://customer-assets.emergentagent.com/job_rentflow-67/artifacts/zjs6jlz1_ChatGPT%20Image%20Feb%201%2C%202026%2C%2007_47_29%20PM.png";

const statusStyles = {
  paid: "status-badge status-paid",
  pending: "status-badge status-pending",
  overdue: "status-badge status-overdue"
};

const statusLabels = {
  paid: "Paid",
  pending: "Pending",
  overdue: "Overdue"
};

export const InvoiceHeader = ({
  companyInfo,
  invoiceInfo,
  isEditing,
  updateCompanyInfo,
  updateInvoiceInfo
}) => {
  return (
    <div className="invoice-header">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        {/* Company Branding */}
        <div className="flex items-center gap-4">
          <img 
            src={COMPANY_LOGO} 
            alt="Ak Car Rental" 
            className="h-14 w-auto object-contain"
          />
          <div className="space-y-1">
            {isEditing ? (
              <>
                <Input
                  value={companyInfo.name}
                  onChange={(e) => updateCompanyInfo("name", e.target.value)}
                  className="text-xl font-bold bg-primary-foreground/10 border-primary-foreground/30 text-primary-foreground placeholder:text-primary-foreground/50 h-auto py-1"
                  placeholder="Company Name"
                />
                <p className="text-primary-foreground/80 text-sm font-medium">1001437133 ONTARIO INC.</p>
              </>
            ) : (
              <>
                <h1 className="text-xl sm:text-2xl font-bold text-primary-foreground">
                  {companyInfo.name}
                </h1>
                <p className="text-primary-foreground/80 text-sm font-medium">1001437133 ONTARIO INC.</p>
              </>
            )}
          </div>
        </div>

        {/* Invoice Badge & Number */}
        <div className="flex flex-col items-start sm:items-end gap-2">
          <div className="flex items-center gap-3">
            <FileText className="w-5 h-5 text-primary-foreground/70" />
            <span className="text-2xl sm:text-3xl font-bold text-primary-foreground tracking-tight">
              INVOICE
            </span>
          </div>
          <div className="flex items-center gap-3">
            {isEditing ? (
              <Input
                value={invoiceInfo.number}
                onChange={(e) => updateInvoiceInfo("number", e.target.value)}
                className="text-sm bg-primary-foreground/10 border-primary-foreground/30 text-primary-foreground placeholder:text-primary-foreground/50 w-40 h-8"
                placeholder="Invoice Number"
              />
            ) : (
              <span className="text-primary-foreground/90 font-mono text-sm">
                #{invoiceInfo.number}
              </span>
            )}
            <span className={statusStyles[invoiceInfo.status]}>
              {statusLabels[invoiceInfo.status]}
            </span>
          </div>
          {/* HST Number Display in Header */}
          {companyInfo.hstNumber && !isEditing && (
            <span className="text-primary-foreground/60 text-xs">
              HST #: {companyInfo.hstNumber}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
